<template>
  <!--
    SLOTS:
      emptyTableSlot

    SLOTS-PASS-THROUGH:
      tableHeader
      normal

    -->
  <styled-table v-bind="tableProps" ref="table">

    <template slot="tableHeader">
      <slot name="tableHeader"></slot>
    </template>

    <template slot="loading">
      <!-- <h1>Filtering the data</h1> -->
      <loader-dots class="emptyTableLayout__loader"></loader-dots>
    </template>

    <slot></slot>

    <template slot='empty'>
      <template v-if="loading">
        <loader-dots class="emptyTableLayout__loader" v-if="loading"></loader-dots>
      </template>
      <template v-else>
        <empty-table v-bind="emptyTableProps">
        <!-- When empty enter your component here -->
          <slot name="emptyTableSlot"></slot>
        </empty-table>
      </template>
    </template>
  </styled-table>
</template>

<script>
import LoaderDots from '@/components/common/loaderDots'
import EmptyTable from './EmptyTable'
import {StyledTable} from '@/components/common/tables/'

export default {
  components: {
    LoaderDots,
    EmptyTable,
    StyledTable
  },
  props: {
    loading: Boolean,
    emptyTableProps: Object,
    tableProps: Object
  },
  computed: {
    table () {
      return this.$refs.table.table
    }
  }
}
</script>

<style style="scss">
.emptyTableLayout__loader {
  position: absolute !important;
  left: 50%;
  top: 30%;
  transform: translate(-50%);
}
</style>



// WEBPACK FOOTER //
// StyledEmptyTableLayout.vue?382fcdae